import React from 'react';
import { EmployeeHistory as JobHistory } from '../../../types/interfaces';
import { useTranslation } from 'react-i18next';

interface EmployeeHistoryProps {
  jobHistory: JobHistory[];
}

const EmployeeHistory: React.FC<EmployeeHistoryProps> = ({ jobHistory }) => {
  const { t } = useTranslation();

  if (!jobHistory || jobHistory.length === 0) {
    return (
      <div className="p-8">
        <h2 className="text-3xl font-bold mb-4 text-center">{t('employeeHistory.title')}</h2>
        <p className="text-center">{t('employeeHistory.no_history')}</p>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h2 className="text-3xl font-bold mb-4 text-center">{t('employeeHistory.title')}</h2>

      <div
        className="relative overflow-x-auto bg-white px-2 py-2 rounded-lg shadow-lg"
        style={{ boxShadow: '0px 4px 10px rgba(169, 169, 169, 0.6)' }}
      >
        <table className="min-w-full text-left bg-white border rounded-lg">
          <thead className="bg-gray-800 text-white">
            <tr>
              <th className="py-3 px-2 text-sm font-semibold tracking-wider text-center">
                {t('employeeHistory.table.organization')}
              </th>
              <th className="py-3 px-2 text-sm font-semibold tracking-wider text-center">
                {t('employeeHistory.table.title')}
              </th>
              <th className="py-3 px-2 text-sm font-semibold tracking-wider text-center">
                {t('employeeHistory.table.start_date')}
              </th>
              <th className="py-3 px-2 text-sm font-semibold tracking-wider text-center">
                {t('employeeHistory.table.end_date')}
              </th>
            </tr>
          </thead>
          <tbody>
            {jobHistory.map((history, index) => (
              <tr key={index} className="text-center bg-gray-50 even:bg-gray-100 hover:bg-gray-200">
                <td className="py-3 px-2 border">
                  <div className="flex items-center justify-center">
                    {history.logo_url && (
                      <img
                        src={history.logo_url}
                        alt={history.organization_name || t('employeeHistory.unknown_organization')}
                        className="h-6 w-6 mr-1"
                      />
                    )}
                    <span>{history.organization_name || t('employeeHistory.unknown_organization')}</span>
                  </div>
                </td>
                <td className="py-3 px-2 border">{history.title || t('employeeHistory.no_title')}</td>
                <td className="py-3 px-2 border">
                  {history.start_date ? new Date(history.start_date).toLocaleDateString() : '-'}
                </td>
                <td className="py-3 px-2 border">
                  {history.end_date ? new Date(history.end_date).toLocaleDateString() : t('employeeHistory.present')}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeeHistory;
